import React from 'react';

import Wrapper from '../../../wrapper/wrapper.jsx';
import {useConnectionContext} from '../connection-context.js';
import {useConnectionListContext} from '../../connection-list-context.js';
import {useAppContext} from 'app-context.js';

import ChatId from './chat-id/chat-id';
import Id from './id/id.jsx';
import Key from './key/key.jsx';
import PaymentDate from './payment-date/payment-date.jsx';
import PhoneNumber from './phone-number/phone-number.jsx';
import Tariff from './tariff/tariff.jsx';
import Username from './username/username.jsx';
import WebhookUrl from './webhook-url/webhook-url';
import Place from './place/place.jsx';

const Info = () => {
  const {user} = useAppContext();
  const {client} = useConnectionListContext();
  const {connection} = useConnectionContext();

  const isKey =
    !!(!connection.is_limited || user.widget_code) && !client.isCustomer;

  const isWebhookUrlShown =
    (client.crm == 'PIPEDRIVE' || client.crm == 'TGPIPEDRIVE') &&
    !client.isCustomer &&
    connection.phone;

  return (
    <Wrapper isColumn>
      <Tariff />
      <PaymentDate />
      <Username />
      <PhoneNumber />
      <Place />
      <ChatId />
      {isKey && <Key />}
      <Id />
      {isWebhookUrlShown && <WebhookUrl />}
    </Wrapper>
  );
};

export default Info;
